import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { WithdrawStackRoutes, WithdrawStackScreenProps } from './type';
import { WithdrawWebMainScreen } from './WithdrawWebMain.screen';
import { WithdrawNativeMainScreen } from './WithdrawNativeMain.screen';

export const WithdrawMain: React.FC<WithdrawStackScreenProps<WithdrawStackRoutes.Main>> = ({ navigation, route }) => {
  const { onLayout, onData, func, record, onReturnData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <WithdrawNativeMainScreen
        onClose={onGoBack}
        onLayout={onLayout}
        onData={onData}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
        record={record}
      />
    );
  }

  return (
    <WithdrawWebMainScreen
      onClose={closeModal}
      onLayout={onLayout}
      onData={onData}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
      record={record}
    />
  );
};
